import { format } from 'date-fns'
import moment, { Moment } from 'moment-timezone'
import { getLocalFromLanguage } from '@/modules/helper/languageHelper.ts'

export interface Minute {
    id: string
    minutes: string
}

export interface Hour {
    id: string
    hours: string
}

export interface Month {
    id: string
    months: string
}

export interface Day {
    id: string
    days: string
}

export interface Year {
    id: string
    years: string
}

export function initMinuteTab(): Array<Minute> {
    const minutesTab: Array<Minute> = []
    const allMinute: Minute = {
        id: '*',
        minutes: 'toutes'
    }
    minutesTab.push(allMinute)
    for (let i: number = 0; i <= 60; i++) {
        const minute: Minute = {
            id: i.toString(),
            minutes: i.toString()
        }
        if (minute.id.length === 1) {
            minute.id = `0${i.toString()}`
            minute.minutes = `0${i.toString()}`
        }
        minutesTab.push(minute)
    }
    return minutesTab
}

export function initHourTab(): Array<Hour> {
    const hourTab: Array<Hour> = []
    const allHours: Hour = {
        id: '*',
        hours: 'toutes'
    }
    hourTab.push(allHours)
    for (let i: number = 0; i <= 24; i++) {
        const hour: Hour = {
            id: i.toString(),
            hours: i.toString()
        }
        if (hour.id.length === 1) {
            hour.id = `0${i.toString()}`
            hour.hours = `0${i.toString()}`
        }
        hourTab.push(hour)
    }
    return hourTab
}

export function initMonthTab(): Array<Month> {
    const monthTab: Array<Month> = []
    const allMonths: Month = {
        id: '*',
        months: 'tous'
    }
    monthTab.push(allMonths)
    for (let i: number = 0; i <= 12; i++) {
        const month: Month = {
            id: i.toString(),
            months: findMonth(i)
        }
        monthTab.push(month)
    }
    return monthTab
}

export function initDayTab(): Array<Day> {
    const dayTab: Array<Day> = []
    const allDays: Day = {
        id: '*',
        days: 'tous'
    }
    dayTab.push(allDays)
    for (let i: number = 1; i <= 7; i++) {
        const day: Day = {
            id: findEnglishDay(i),
            days: findDay(i)
        }
        dayTab.push(day)
    }
    for (let i: number = 0; i <= 31; i++) {
        const day: Day = {
            id: i.toString(),
            days: i.toString()
        }
        dayTab.push(day)
    }
    return dayTab
}

export function initYearsTab(start: number = 2020): Array<Year> {
    const date: number = moment().year()
    const yearTab: Array<Year> = []
    for (let i: number = start; i <= date; i++) {
        const year: Year = {
            id: i.toString(),
            years: i.toString()
        }
        yearTab.push(year)
    }
    return yearTab
}

export function initMonthsTab(start: string): Array<Month> {
    const current: Moment = moment().subtract(1, 'months').startOf('month')
    const min: Moment = moment(start, 'DD-MM-YYYY').startOf('month')

    const months: Array<Month> = []

    while (current.isSameOrAfter(min)) {
        const monthName: string = format(current.toDate(), 'MMMM', {
            locale: getLocalFromLanguage()
        })
        months.push({
            id: current.format('MM-YYYY'),
            months: monthName.charAt(0).toUpperCase() + monthName.slice(1) + ' ' + current.format('YYYY')
        })
        current.subtract(1, 'month')
    }

    return months.reverse()
}

function findEnglishDay(nb: number): string {
    switch (nb) {
        case 1:
            return 'mon'
        case 2:
            return 'tue'
        case 3:
            return 'wed'
        case 4:
            return 'thu'
        case 5:
            return 'fri'
        case 6:
            return 'sat'
        case 7:
            return 'sun'
        default:
            return ''
    }
}

function findDay(nb: number): string {
    switch (nb) {
        case 1:
            return 'Lundi'
        case 2:
            return 'Mardi'
        case 3:
            return 'Mercredi'
        case 4:
            return 'Jeudi'
        case 5:
            return 'Vendredi'
        case 6:
            return 'Samedi'
        case 7:
            return 'Dimanche'
        default:
            return ''
    }
}

function findMonth(nb: number): string {
    switch (nb) {
        case 0:
            return 'Janvier'
        case 1:
            return 'Février'
        case 2:
            return 'Mars'
        case 3:
            return 'Avril'
        case 4:
            return 'Mai'
        case 5:
            return 'Juin'
        case 6:
            return 'Juillet'
        case 7:
            return 'Aout'
        case 8:
            return 'Septembre'
        case 9:
            return 'Octobre'
        case 10:
            return 'Novembre'
        case 11:
            return 'Décembre'
        default:
            return ''
    }
}
